// document.addEventListener("DOMContentLoaded", function() {
    
//   var savedMenu = localStorage.getItem("activeMenu");
//   if (savedMenu) {
//     $(".header__primary-nav .contents li[data-title='" + savedMenu + "']").addClass("active");
//   }

//   $(document).on("click", ".header__primary-nav .contents li", function() {alert(2);
//     var menuTitle = $(this).attr("data-title");

//     $(".header__primary-nav .contents li").removeClass("active");

//     $(this).addClass("active");

//     if (menuTitle) {
//       localStorage.setItem("activeMenu", menuTitle);
//     }
//   });

// });

document.addEventListener("DOMContentLoaded", function () {
  // Restore saved menu
  var savedMenu = localStorage.getItem("activeMenu");
  if (savedMenu) {
    var savedEl = document.querySelector(
      ".header__primary-nav .contents li[data-title='" + savedMenu + "']"
    );
    if (savedEl) {
      savedEl.classList.add("active");
    }
  }

  // Add click listeners to menu items
  var menuItems = document.querySelectorAll(".header__primary-nav .contents li");
  menuItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var menuTitle = this.getAttribute("data-title");

      // Remove old active
      menuItems.forEach(function (el) {
        el.classList.remove("active");
      });

      // Add new active
      this.classList.add("active");

      // Save to localStorage
      if (menuTitle) {
        localStorage.setItem("activeMenu", menuTitle);
      }
    });
  });
});


